import React from 'react';

function createNavigationContainer(TopLevelComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.isTopLevel = this.isTopLevel.bind(this);
      this.getCurrent = this.getCurrent.bind(this);
      this.gotoPrevComponent = this.gotoPrevComponent.bind(this);
      this.addComponentToPath = this.addComponentToPath.bind(this);
      this.reset = this.reset.bind(this);

      this.state = {
        path: []
      };
    }

    isTopLevel() {
      return this.state.path.length === 0;
    }

    getCurrent() {
      const { path } = this.state;

      if (path.length === 0) {
        return { Component: TopLevelComponent };
      }

      return path[path.length - 1];
    }

    gotoPrevComponent() {
      this.setState(({ path }) => {
        if (!path.length) {
          return {};
        }
        return {
          path: path.slice(0, -1)
        };
      });
    }

    addComponentToPath(Component, props = {}) {
      this.setState(({ path }) => {
        return {
          path: path.concat([{ Component, props }])
        };
      });
    }

    reset() {
      this.setState(({ path }) => {
        return {
          path: []
        };
      });
    }

    render() {
      const current = this.getCurrent();
      const CurrentComponent = current.Component;
      const currentProps = current.props || {};
      return (
        <CurrentComponent
          hasPrevComponent={!this.isTopLevel()}
          addComponentToPath={this.addComponentToPath}
          gotoPrevComponent={this.gotoPrevComponent}
          {...this.state}
          {...this.props}
          {...currentProps}
        />
      );
    }
  };
}

export default createNavigationContainer;



// WEBPACK FOOTER //
// ./src/commons/components/createNavigationContainer.jsx